<script setup lang="ts">
import { FormatOptions } from '@apparatix/types/AccountProfiles';
import ProfileBlobContent from './ProfileBlobContent.vue';
import ProfileListContent from './ProfileListContent.vue';
import ProfileTableContent from './ProfileTableContent.vue';
import ProfileCompositeListContent from './ProfileCompositeListContent.vue';
import ProfileSectionContentSwitch from './ProfileSectionContentSwitch.vue';
import { Stack, Typography } from '@apparatix/library/core';

type Props = {
  previousContent: any;
  newContent: any;
  options: FormatOptions;
  markInvalid: boolean;
}

const props = defineProps<Props>();
</script>
<template>
  <Stack class="pb-4 lg:pb-6">
    <Stack :gap="2">
      <Typography variant="section-subheading" class="pastel-yellow" muted>
        <p class="pastel-yellow">
          Previous
        </p>
      </Typography>
      <ProfileSectionContentSwitch :format="props.options.format">
        <template #blob>
          <ProfileBlobContent :contents="props.previousContent" />
        </template>
        <template #composite-list>
          <ProfileCompositeListContent :contents="props.previousContent" />
        </template>
        <template #list>
          <ProfileListContent :contents="props.previousContent" :columns="props.options.columns" />
        </template>
        <template #table>
          <ProfileTableContent :contents="props.previousContent" :columns="props.options.columns" />
        </template>
      </ProfileSectionContentSwitch>
    </Stack>
    <Stack :gap="2">
      <Typography variant="section-subheading" muted>
        <p class="pastel-green">
          New
        </p>
      </Typography>
      <ProfileSectionContentSwitch v-if="!props.markInvalid && props.newContent" :format="props.options.format">
        <template #blob>
          <ProfileBlobContent :contents="props.newContent" />
        </template>
        <template #composite-list>
          <ProfileCompositeListContent :contents="props.newContent" />
        </template>
        <template #list>
          <ProfileListContent :contents="props.newContent" :columns="props.options.columns" />
        </template>
        <template #table>
          <ProfileTableContent :contents="props.newContent" :columns="props.options.columns" />
        </template>
      </ProfileSectionContentSwitch>
      <Typography v-if="!props.newContent" variant="body" muted>
        Enter your prompt, then click Send to see the new version
      </Typography>
      <Typography v-if="props.markInvalid" variant="body" muted>
        Unable to process AI response, please try again
      </Typography>
    </Stack>
  </Stack>
</template>

<style scoped>
.pastel-yellow {
    color: #F9E79F;
}

.pastel-green {
    color: #A8E6A1;
}
</style>
